import styled from "styled-components";

export const Overlay = styled.div`
  @media screen and (max-width: 768px) {
    display: none;
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    right: 0;
    z-index: 30;
    background-color: #00000090;
    backdrop-filter: blur(10px);

    &.open {
      display: block;
    }
  }
`;

export const Wrapper = styled.div`
  padding-bottom: 4px;
  min-height: 100vh;
  width: 240px;
  position: fixed;
  top: 0;
  background: #021128;
  color: #fff;
  z-index: 12;

  .logo {
    padding: 12px 24px;
    display: flex;
    align-items: center;
    gap: 5.36px;
  }

  .top-section {
    height: calc(100vh - 228px);
    overflow-y: scroll;
    border-top: 1px solid rgba(204, 204, 204, 0.2);

    &::-webkit-scrollbar {
      width: 6px;
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      cursor: pointer;
      border-radius: 15px;
      background: rgba(204, 204, 204, 0.8);
    }
  }

  .image-with-dot {
    position: relative;

    .dot {
      position: absolute;
      z-index: 1;
      right: -3px;
      top: -3px;
      width: 6px;
      height: 6px;
      background: #fd0403;
      border-radius: 50%;
    }

    .green-dot {
      background: var(--success);
      width: 8px;
      height: 8px;
      right: 0;
      top: 0;
    }
  }

  .brands-header {
    font-weight: 450;
    font-size: 10px;
    line-height: 16px;
    letter-spacing: 1px;
  }

  @media screen and (max-width: 768px) {
    position: fixed;
    min-height: 100vh;
    left: -100%;
    top: 0;
    z-index: 40;
    transition: all 0.2s ease-out;

    &.open {
      width: 87%;
      left: 0;
    }
  }
`;

export const Brands = styled.div`
  padding: 12px 24px;
  position: sticky;
  top: 0;
  background-color: #021128;
  z-index: 3;

  .brands-dropdown {
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;

    .brand-name-flex {
      max-width: 90%;
    }

    .brand-name {
      font-size: 14px;
      font-weight: 700;
      line-height: 18px;
    }
  }

  .close-icon {
    float: right;
    margin-top: -25px;
    display: none;
  }

  @media screen and (max-width: 768px) {
    .close-icon {
      display: block;
    }
  }
`;

export const ArrowWrapper = styled.button`
  width: 20px;
  height: 20px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
    background: #031f48;
  }
`;

export const Menu = styled.div`
  margin: 12px 0 100px;
  color: #cccccc;
  padding: 0 12px;

  .icon {
    width: 16px;
    height: 16px;
  }

  li a,
  .linkGroupWrapper {
    padding: 12px 14px;
    border-radius: 6px;
    text-decoration: none;
    display: block;
    font-weight: 450;
    font-size: 14px;
    line-height: 18px;
    color: #cccccc;
    margin-bottom: 5px;

    &:hover {
      background: rgba(3, 31, 72, 0.9);
      color: #fff;
      .icon {
        filter: brightness(150%);
      }
    }

    &:focus {
      outline: none;
    }

    img {
      width: 16px;
      height: 16px;
    }
  }

  .linkGroup {
    display: flex;
    align-items: center;
    gap: 8px;

    &.coming-soon {
      gap: 0;

      .icon,
      .text {
        opacity: 0.3;
      }

      .text {
        white-space: nowrap;
        margin-left: 8px;
      }

      .tag {
        font-size: 8px;
        line-height: 12px;
        background-color: #ffe8d8;
        padding: 3px 6px;
        margin-left: 3px;
        white-space: nowrap;
        border-radius: 8px;
        color: var(--text);
      }
    }
  }

  .active {
    background: rgba(3, 31, 72, 0.9);
    color: #fff;
    font-weight: 700;

    .icon {
      filter: brightness(150%);
    }
  }

  .subLinks {
    padding-left: 24px;

    .active {
      background: transparent;
      color: var(--secondary);
    }
  }
`;

export const BottomSection = styled.div`
  position: absolute;
  height: 240px;
  bottom: 0;
  left: 0;
  width: 100%;
  border-top: 1px solid rgba(204, 204, 204, 0.2);
  background-color: #021128;
  z-index: 3;
  padding-top: 2px;

  .workspace-header {
    padding-left: 24px;
    font-weight: 450;
    font-size: 10px;
    line-height: 16px;
    letter-spacing: 1px;
  }

  .workspace_acc + .workspace_acc {
    margin-left: -10px;
  }

  @media screen and (max-width: 768px) {
    height: 255px;
  }
`;

export const WorkspaceContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding-left: 24px;
  padding-right: 16px;
  cursor: pointer;
  border-top: 1px solid rgba(204, 204, 204, 0.2);
  position: relative;

  .workspace_name {
    overflow: hidden;
    color: rgba(204, 204, 204, 0.8);
    text-overflow: ellipsis;
    font-size: 12px;
    font-weight: 450;
    line-height: 16px;
  }

  .arrow-icon {
    transform: rotate(270deg);
    width: 20px;
    height: 20px;
  }

  .wrapper {
    max-width: 25px;
  }

  .workspaces .wrapper:nth-child(2) {
    z-index: -1;
  }
  .workspaces .wrapper:nth-child(3) {
    z-index: -2;
  }
  .workspaces .wrapper:nth-child(4) {
    z-index: -3;
  }

  .workspaces .wrapper:nth-child(2) .imgWrapper {
    background: var(--secondary);
  }
  .workspaces .wrapper:nth-child(3) .imgWrapper {
    background: var(--warning);
  }
  .workspaces .wrapper:nth-child(4) .imgWrapper {
    background: var(--success);
  }

  .workspace {
    width: 32px;
    height: 32px;
    background: #032250;
    border-radius: 50%;
    font-weight: 450;
    font-size: 12px;
  }
`;

export const WorkspaceMenu = styled.div`
  padding: 0 12px;
  color: #cccccc;

  .icon {
    width: 16px;
    height: 16px;
  }

  .menu-list a,
  button {
    padding: 12px 14px;
    border-radius: 6px;
    text-decoration: none;
    display: block;
    font-weight: 450;
    font-size: 14px;
    line-height: 18px;
    color: #cccccc;
    margin-bottom: 3px;

    &:hover {
      background: rgba(3, 31, 72, 0.9);
      color: #fff;
      .icon {
        filter: brightness(150%);
      }
    }

    &:focus {
      outline: none;
    }
  }

  .linkGroup {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .active {
    background: rgba(3, 31, 72, 0.9);
    color: #fff;
    font-weight: 700 !important;
    .icon {
      filter: brightness(150%);
    }
  }
`;

export const BrandSwitcher = styled.div`
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--primary);
  border-radius: 12px;
  margin: 12px;
  height: 56px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: var(--primary_light);
  }

  .brand-header {
    display: flex;
    flex: 1;
    align-items: center;
    gap: 12px;
  }

  .brand-icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #ff6b35;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: bold;
    font-size: 14px;
    text-transform: uppercase;
  }

  .brand-info {
    display: flex;
    flex-direction: column;
  }

  .brand {
    color: var(--grey_8);
    font-size: 10px;
    text-transform: uppercase;
    font-weight: 500;
  }

  .brand-name {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 0;
    color: var(--grey_11);
  }

  .switch-button {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;

    .switch-button-icon {
      width: 20px;
    }
  }
`;
